
import notice from "./notice"
import common from "./common"
import app from "./app"
import Qs from 'qs'
import axios from 'axios';

function request(params) {
  if (!params.url && !params.href) return;
  return new Promise((resolve, reject) => {
    let data = getParams(params);
    var root = ""
    if (common.env == 2) {
      // root="https://channel.fxyf99.com";
      // root="http://bp.lzyunying.com";
      root = "https://channel.wts9999.net";
      // root = "http://192.168.33.30:8080";
    }else{
      // root = location.origin.replace("http:","https:");//强制https
    }
    // root = root.replace("https:","").replace("http:","");//触发自动设置协议头
    let responseType = params.responseType || null
    let headers = params.headers || {};
    const method = params.type || 'POST';
    if (params.href) {
      params.url = params.href
      root = ''
    }
    var token = localStorage.token;
    if (token) {
      headers["token"] = token
    }
    if (common.token) {
      headers["token"] = common.token
    }
    if(sessionStorage.refundSign) {
      headers["sign"] = sessionStorage.refundSign;
      delete headers.token;
    }
    headers.devicekey = sessionStorage.devicekey||'';
    return axios({
      method: method,
      url: params.url,
      data: method === 'POST' || method === 'PUT' ? data : null,
      params: method === 'GET' || method === 'DELETE' ? data : null,
      baseURL: root,
      headers: headers,
      responseType: responseType?responseType:null,
      /**end */
      withCredentials: true
    })
      .then(function (res) {
        let isErr = hasError(res.data, params);
        if (isErr) {
          reject(res.data)
        } else {
          if(params.responseType &&params.responseType == 'blob'){
            resolve(res)
          }else{
            resolve(res.data)
          }
        }
      })
      .catch(function (err) {
        let res = err.response
        reject(err)
        if (res) {
          window.alert('api error, HTTP CODE: ' + res.status)
        }
      })

  });
};

// 接口参数校验和转换
function getParams(params) {
  let result;
  if (params.data) {
    result = filterNull(params.data)
  }
  if (params.contentType == 'from') {
    result = getURLSearchParams(result)
  }
  return result;
}

//公共错误处理
function hasError(data, params) {
  if (data.httpCode != 1) {
    const whiteUrl = []
    if(whiteUrl.indexOf(params.url) == -1) {//不在白名单中
      if(data.httpCode == 100001) {// 100001：token失效
        console.log("登录失效",params.url,data);
        localStorage.token = "";
        sessionStorage.loginPage = location.href;
        location.replace("/m/login");
        return true;
      }
    }
    if(params.responseType &&params.responseType == 'blob'){
      return false
    }
    (!params.hideAlert) && setLayer(data.msg);
    return true;
  }
  return false
}

function setLayer(msg) {
  notice.alert(msg)
}
// 自定义判断元素类型JS
function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}
// 表单提交字段转换
function getURLSearchParams(params) {
  let data = Qs.stringify(params);
  return data;
}
export default request
